import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {User} from '../../features/login/models/user';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Login Success': props<User>(),
    'Logout': props<{ spid: boolean }>(),
    'Check Session': emptyProps(),
  },
});
